import { Controller } from "@hotwired/stimulus";
import debounce from "lodash/debounce";

export default class extends Controller {
  static values = { delay: { type: Number, default: 250 } };

  connect() {
    this.debouncedSubmit = debounce(
      () => this.element.requestSubmit(),
      this.delayValue
    );
  }

  disconnect() {
    this.debouncedSubmit?.cancel?.();
  }

  submit() {
    this.debouncedSubmit();
  }
}
